import * as Styled from './styles';
import * as SX from './sx';

import { classnames, fDate, fHumanReadableNumber } from '@aibees/shared/utils';
import { Paper, Typography } from '@mui/material';

import { memo } from 'react';
import type { AccountPopoverCreditPlanDetailProps as Props } from './types';
import { useAccountPopoverCreditPlanDetail } from './use-account-popover-credit-plan-detail';

export const AccountPopoverCreditPlanDetail = memo(
  ({ className, toRoute, variant = 'popover' }: Props) => {
    const { showRolloverHint, rollOver, renewalDate } =
      useAccountPopoverCreditPlanDetail();

    const formattedDate = fDate(renewalDate);
    const isPopover = variant === 'popover';

    return (
      <Styled.Wrapper
        className={classnames('AccountPopoverCreditPlanDetail', className)}
        sx={SX.root(variant)}
      >
        <Paper elevation={0} sx={SX.card(variant)}>
          <Typography variant="body4" color="grey.700">
            {showRolloverHint ? (
              <>
                Use your{' '}
                <Typography
                  component="span"
                  variant="body4"
                  fontWeight={700}
                  color="grey.800"
                >
                  {fHumanReadableNumber(rollOver)}
                </Typography>{' '}
                rollover credits before {isPopover ? <br /> : ' '}
                <Typography
                  component="span"
                  variant="body4"
                  fontWeight={700}
                  color="grey.800"
                >
                  {formattedDate}
                </Typography>
              </>
            ) : (
              <>
                Renews on{' '}
                <Typography
                  component="span"
                  variant="body4"
                  fontWeight={700}
                  color="grey.800"
                >
                  {formattedDate}
                </Typography>
              </>
            )}
          </Typography>
        </Paper>
      </Styled.Wrapper>
    );
  }
);

AccountPopoverCreditPlanDetail.displayName = 'AccountPopoverCreditPlanDetail';
